angular.module("vgresiduos").controller("SupplierProfileEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/fornecedores/perfil/${$stateParams.id}`);
		};
	}
]);
